import { render, staticRenderFns } from "./DocumentDashboard.vue?vue&type=template&id=a66ee190&scoped=true&"
import script from "./DocumentDashboard.vue?vue&type=script&lang=js&"
export * from "./DocumentDashboard.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/document_dashboard.scss?vue&type=style&index=0&id=a66ee190&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66ee190",
  null
  
)

export default component.exports